import { jsxs as o, jsx as n } from "react/jsx-runtime";
import { TextCardCarousel as E } from "../TextCardCarousel/index.js";
import { CarouselHeader as a } from "../CarouselHeader/index.js";
function D(r) {
  var e, t, C, R;
  return /* @__PURE__ */ o("div", { children: [
    /* @__PURE__ */ n(
      a,
      {
        reviewCount: r == null ? void 0 : r.reviewCount,
        rating: r.rating,
        slug: r.slug,
        textColor: (e = r.config) == null ? void 0 : e.headerTextColor,
        alignment: (t = r.config) == null ? void 0 : t.headerAlignment
      }
    ),
    /* @__PURE__ */ n(
      E,
      {
        reviews: r.reviews,
        textCardBackgroundColor: (C = r.config) == null ? void 0 : C.textCardBackgroundColor,
        hasControls: (R = r.config) == null ? void 0 : R.hasControls
      }
    )
  ] });
}
var _ = /* @__PURE__ */ ((r) => (r.MICRO_STARS = "MICRO_STARS", r.HEADER_BAR_STARS = "HEADER_BAR_STARS", r.REVIEW_CARDS = "REVIEW_CARDS", r.BEFORE_AFTER_CARDS = "BEFORE_AFTER_CARDS", r.VIDEO_CARDS = "VIDEO_CARDS", r.TEXT_VIDEO_CARDS = "TEXT_VIDEO_CARDS", r))(_ || {}), A = /* @__PURE__ */ ((r) => (r.left = "left", r.right = "right", r.center = "center", r))(A || {});
export {
  A as Alignment,
  D as TextCardsCarouselWidget,
  _ as WidgetType
};
